module.exports = __webpack_public_path__ + "static/media/option.c2c20e25.svg";